import React, { type ComponentProps } from 'react';
import { Platform, StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { TextField } from '../../TextField';
import { TextFieldZipCode } from '../TextFieldZipCode';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Wrapper for the TextField component.
 * Adds a background color with some padding.
 * Removes the bottom border and the floating label.
 */
export const TextFieldWithBackground = (props: ComponentProps<typeof TextField>) => {
  return (
    <TextField
      wrapperStyle={[styles.wrapper, props.wrapperStyle]}
      style={[styles.field, props.style]}
      {...props}
    />
  );
};

export const TextFieldZipCodeWithBackground = (props: ComponentProps<typeof TextField>) => {
  return (
    <TextFieldZipCode
      wrapperStyle={[styles.wrapper, props.wrapperStyle]}
      style={[styles.field, props.style]}
      {...props}
    />
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    borderRadius: theme.radius.medium,
    paddingVertical: Platform.select({
      android: theme.spacing['3'],
      default: theme.spacing['4'],
    }),
    paddingHorizontal: theme.spacing['3'],
    borderBottomWidth: 0,
  },
  field: {
    lineHeight: Platform.select({
      android: theme.spacing['4'],
      default: undefined,
    }),
    height: 'auto',
  },
});
